module.exports = __webpack_public_path__ + "img/logo_netzebw.647df6a3.svg";